const Footer = () => {
  const toolLinks = [
    { href: '/tool/pdf-compressor', label: 'PDF 压缩' },
    { href: '/tool/pdf-rotate', label: 'PDF 页面旋转' },
    { href: '/tool/pdf-to-images', label: 'PDF 转图片' },
    { href: '/tool/image-compressor', label: '图片压缩' },
    { href: '/tool/image-watermark', label: '图片加水印' }
  ]

  const developerLinks = [
    { href: '/tool/json-formatter', label: 'JSON 格式化' },
    { href: '/tool/timestamp-converter', label: '时间戳转换' },
    { href: '/tool/base64-codec', label: 'Base64 编解码' },
    { href: '/tool/url-codec', label: 'URL 编解码' }
  ]

  const siteLinks = [
    { href: '/', label: '首页' },
    { href: '/guides/', label: '资料库' },
    { href: '/tools', label: '在线工具' },
    { href: '/nsdq/', label: '纳指看板' },
    { href: '/kids/', label: '亲子资源库' },
    { href: '/about', label: '关于本站' },
    { href: '/privacy', label: '隐私政策' },
    { href: '/contact', label: '联系我们' },
    { href: '/disclaimer', label: '免责声明' },
    { href: '/search-indexing', label: '收录指引' },
    { href: '/sitemap.xml', label: 'Sitemap' }
  ]

  return (
    <footer className="bg-slate-950 text-white">
      <div className="container mx-auto px-4 py-10">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div>
            <h3 className="text-lg font-semibold mb-4">Parentool 工具站</h3>
            <p className="text-slate-300 text-sm mb-2">
              面向办公、图片、PDF 和开发调试场景的轻量在线工具集合。
            </p>
            <p className="text-slate-500 text-xs leading-5">
              文件类工具优先在浏览器本地处理；跨设备剪切板仅保存临时文本，并会按过期时间清理。
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">常用办公工具</h3>
            <ul className="space-y-2 text-sm">
              {toolLinks.map(link => (
                <li key={link.href}>
                  <a href={link.href} className="text-slate-300 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">开发与文本工具</h3>
            <ul className="space-y-2 text-sm">
              {developerLinks.map(link => (
                <li key={link.href}>
                  <a href={link.href} className="text-slate-300 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">站点信息</h3>
            <ul className="space-y-2 text-sm">
              {siteLinks.map(link => (
                <li key={link.href}>
                  <a href={link.href} className="text-slate-300 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-6 text-center text-sm text-slate-500">
          <p>&copy; 2026 parentool.cn. Built for useful tools.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
